export async function getUserIp(): Promise<string | null> {
  try {
    const resp = await fetch("https://api.ipify.org?format=json");
    if (!resp.ok) return null;
    const data = await resp.json();
    return data.ip as string;
  } catch (err) {
    console.error("Erro ao buscar IP:", err);
    return null;
  }
}
